// Core
import { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Chakra imports
import { ChakraProvider, Center, Box, Spinner, Image, Portal, useDisclosure, useColorModeValue } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../theme/theme.js';

export default function Loader(props) {
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <Center h="100vh" w="100%" overflow="hidden">
        <Image objectFit="cover" overflow="hidden" src="/loader.png" alt="Loading..." w="100%" h="100%" />
          <Box position="absolute" bottom="40%" w="60px" h="60px">
            <Spinner fontSize="140px" color="white" style={{ width: '100%', height: '100%' }} />
          </Box>
      </Center>
    </ChakraProvider>
  );
}
